export default "__VITE_ASSET__BJfMCfgc__"